import { SectionHead } from '../../../tokens';
import BusinessUnderstandingExperience from '../experiences/BusinessUnderstanding/BusinessUnderstandingExperience';

// Thin wrapper: the Business Intelligence tab now hosts the Business Understanding
// experience. Persisted-state props are owned by CompassModule and passed straight
// through, so the conversation survives Compass internal tab switches.
export default function BusinessIntelligenceTab({ companyName, subjectId, persistedState, onStateChange }) {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <SectionHead title="Business Intelligence" sub="The structured model of this business that Compass reasons over." />
      <BusinessUnderstandingExperience
        companyName={companyName}
        subjectId={subjectId}
        persistedState={persistedState}
        onStateChange={onStateChange}
      />
    </div>
  );
}
